import { Dropoff } from "@domain/CRM/dropoff";
import { DataAPI_Base, GetAPI_Base } from "../base";

class GetAPI_Dropoffs extends GetAPI_Base<Dropoff> {
	constructor() {
		super("dropoffs", Dropoff);
	}
}

export class DropoffsAPI extends DataAPI_Base<Dropoff> {
	get: GetAPI_Dropoffs;
	constructor() {
		super("dropoffs", Dropoff);
		this.get = new GetAPI_Dropoffs();
	}
}
